import type { Order } from '@src/domains/orders/types/order';
import { getOrderSaleItems } from '@src/domains/orders/core/getOrderSaleItems';
import type { DetailedSaleItem } from '@src/domains/sales';

export interface SellerTemplateOrder extends Order {
  items: DetailedSaleItem[];
  state: Order['status'];
  /** Snake case and the deprecated cents field are part of the contract sellers already read. */
  total_amount_cents: number;
}

/**
 * Shape of the order handed to the seller's own page through the checkout callbacks.
 * It is a public contract with templates written outside this codebase, so the flattened
 * `items`, `state` and `total_amount_cents` have to stay.
 */
export const toSellerTemplateOrder = (order: Order): SellerTemplateOrder => ({
  ...order,
  items: getOrderSaleItems(order),
  state: order.status,
  total_amount_cents: order.finalAmountCents,
});
